import { render, staticRenderFns } from "./dealerTisk.vue?vue&type=template&id=5057e0aa&scoped=true"
import script from "./dealerTisk.vue?vue&type=script&lang=js"
export * from "./dealerTisk.vue?vue&type=script&lang=js"
import style0 from "./dealerTisk.vue?vue&type=style&index=0&id=5057e0aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5057e0aa",
  null
  
)

export default component.exports